import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import pipe from 'ramda/src/pipe';
import pathOr from 'ramda/src/pathOr';

type Props = {
  className?: string,
  // TODO: Migrate to MUI v5 and use `sx` prop
  style?: React.CSSProperties,
  /** Default: true */
  isEnabled?: boolean,
  adKey: string

}

const EditAdButton: React.FC<Props> = ({adKey, style, className, isEnabled}) => {
  const handleEditAd: React.MouseEventHandler = pipe(
    pathOr<string>('missing-key', ['currentTarget', 'dataset', 'key']),
    (key: string) =>
      window.location.href = `/edit/${encodeURIComponent(key)}`
  );

  switch (isEnabled)
  {
    case false:
      // Additional span element is needed for MUI tooltip
      // to work on a disabled element.
      // https://material-ui.com/components/tooltips/#disabled-elements
      return <Tooltip title="Ad has already been programmed.">
        <span>
          <Button
            className={className}
            style={style}
            type="button"
            color="primary"
            variant="outlined"
            disabled={true}
            data-key={adKey}
            onClick={handleEditAd}
          >Edit</Button>
        </span>
      </Tooltip>;

    default:
      return <Button
        className={className}
        style={style}
        type="button"
        color="primary"
        variant="outlined"
        data-key={adKey}
        onClick={handleEditAd}
      >Edit</Button>;
  }
};
export default EditAdButton;
